<template>
    <div>
        <v-dialog v-model="openPopUp" persistent width="370" class="align-center">
            <template>
                <v-card height="auto">
                <v-toolbar :elevation="0" color="primary" dark>
                    <v-toolbar-title>Delete device</v-toolbar-title>
                </v-toolbar>
                    <v-form ref="form" class="text-center my-3">
                        Do you want to delete "{{meter_id}}" device?
                    </v-form>
                    <div align="right" class="align-content-end mx-4">
                        <v-btn color="danger" 
                            small
                            class="white--text mx-2 mb-3" 
                            @click="redirect(meter_id)"
                            :loading="processing"
                            >Delete
                        </v-btn>
                        <v-btn color="danger" 
                            small 
                            text
                            class="mb-3"
                            @click="close"
                            >Cancel
                        </v-btn>
                    </div>
                </v-card>
            </template>
        </v-dialog>
        <v-snackbar v-model="success" :timeout="3000">
            Device deleted successfully
            <template v-slot:action="{ attrs }">
                <v-btn
                    color="error"
                    text
                    v-bind="attrs"
                    @click="success = false"
                >
                    Close
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    name: 'formDelete',
    props: ['openPopUp','meter_id'],
    data() {
        return {
            processing: false,
            success: false
        }
    },
    methods: {
        ...mapActions({ 
            deleteMeter: 'meters/deleteMeter'
        }),
        async redirect(meter_id){
            this.processing = true
            await this.deleteMeter(meter_id)
            await this.sleep(2000).then(() => { this.processing = false; });
            this.sleep(1000).then(() => { this.close(); })
            this.success = true
            this.$router.push({ name:'Main' }).catch(()=>{})                   
        },
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        close(){
            this.$emit('close')
        },
        refreshPage(){
            window.location.reload()
        }
    },
}
</script>